__turbopack_context__.v({
  "card": "SidebarPlan-module__dykIeq__card",
  "collapsed": "SidebarPlan-module__dykIeq__collapsed",
  "fill": "SidebarPlan-module__dykIeq__fill",
  "head": "SidebarPlan-module__dykIeq__head",
  "manage": "SidebarPlan-module__dykIeq__manage",
  "meter": "SidebarPlan-module__dykIeq__meter",
  "meterHead": "SidebarPlan-module__dykIeq__meterHead",
  "meterLabel": "SidebarPlan-module__dykIeq__meterLabel",
  "meterValue": "SidebarPlan-module__dykIeq__meterValue",
  "planName": "SidebarPlan-module__dykIeq__planName",
  "track": "SidebarPlan-module__dykIeq__track",
});
